(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67202);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function Banner(param) {
    var image = param.image, _children = param.children, children = _children === void 0 ? "" : _children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "fit-content" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerContainer),
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.src) || "/img/loading-wall.gif",
                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                width: width,
                layout: "fill",
                objectFit: "cover",
                quality: 100,
                alt: "Hype Empreendimentos",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().childrenContainer),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 59000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonDefault; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90050);
/* harmony import */ var _buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function ButtonDefault(param) {
    var url = param.url, text = param.text, aria = param.aria, _target = param.target, target = _target === void 0 ? "_self" : _target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: url !== null && url !== void 0 ? url : "",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: target,
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    "aria-label": aria,
                    children: text
                })
            })
        })
    });
}


/***/ }),

/***/ 25768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DepoimentosCarousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13056);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _BannerDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50121);
/* harmony import */ var _carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84746);
/* harmony import */ var _carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4__);






function DepoimentosCarousel(param) {
    var _depoimentos = param.depoimentos, depoimentos = _depoimentos === void 0 ? [] : _depoimentos;
    if (!Array.isArray(depoimentos)) {
        depoimentos = [];
    }
    if (true) {
        Array.from(document.getElementsByClassName("MuiButtonBase-root")).forEach(function(element) {
            var ref;
            var ariaElement = (ref = element.getAttribute("aria-label")) === null || ref === void 0 ? void 0 : ref.slice(0, 18);
            if (ariaElement && ariaElement === "carousel indicator") element.setAttribute("tabindex", "-1");
        });
    }
    if (!depoimentos.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BannerDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        image: {
            src: "/img/backgroundpolitica.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: "Experi\xeancias Extraordin\xe1rias"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2___default()), {
                    navButtonsAlwaysVisible: true,
                    autoPlay: true,
                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slider),
                    children: depoimentos.map(function(depoimento) {
                        var ref, ref1, ref2, ref3;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slide),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: depoimento === null || depoimento === void 0 ? void 0 : depoimento.depoimento
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().cliente),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    alt: depoimento === null || depoimento === void 0 ? void 0 : depoimento.nome_cliente,
                                                    src: (depoimento === null || depoimento === void 0 ? void 0 : (ref = depoimento.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url) || (depoimento === null || depoimento === void 0 ? void 0 : (ref3 = depoimento.imagem) === null || ref3 === void 0 ? void 0 : ref3.url),
                                                    loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                                                    layout: "responsive",
                                                    width: "60",
                                                    height: "60",
                                                    priority: true
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    children: [
                                                        "Imagem:",
                                                        "Foto do cliente ".concat(depoimento.nome_cliente)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().infoClient),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: depoimento.nome_cliente
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().emp),
                                                    children: depoimento.empreendimento
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, depoimento === null || depoimento === void 0 ? void 0 : depoimento.nome_cliente);
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 38280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MetaTags(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!data) return null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, _descricao, ref21, ref22;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    (ref8 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref8 !== void 0 ? ref8 : "",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (ref9 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref9 !== void 0 ? ref9 : ""
            }, "metadescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: (ref10 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref10 !== void 0 ? ref10 : ""
            }, "googlename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: (ref11 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref11 !== void 0 ? ref11 : ""
            }, "googledescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.imagem) === null || ref === void 0 ? void 0 : ref.url) !== null && ref12 !== void 0 ? ref12 : ""
            }, "googleimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (ref13 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref13 !== void 0 ? ref13 : ""
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (ref14 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref14 !== void 0 ? ref14 : ""
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (ref15 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref15 !== void 0 ? ref15 : ""
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.imagem) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref16 !== void 0 ? ref16 : ""
            }, "image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.imagem) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref17 !== void 0 ? ref17 : ""
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: (ref18 = data === null || data === void 0 ? void 0 : (ref3 = data.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.width) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref18 !== void 0 ? ref18 : ""
            }, "ogimagewidth"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: (ref19 = data === null || data === void 0 ? void 0 : (ref5 = data.imagem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.height) === null || ref6 === void 0 ? void 0 : ref6.toString()) !== null && ref19 !== void 0 ? ref19 : ""
            }, "ogimageheight"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Hype Empreendimentos"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: (ref20 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref20 !== void 0 ? ref20 : ""
            }, "twittertitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: (_descricao = data.descricao) !== null && _descricao !== void 0 ? _descricao : ""
            }, "twitterdescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: (ref21 = data === null || data === void 0 ? void 0 : (ref7 = data.imagem) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref21 !== void 0 ? ref21 : ""
            }, "twitterimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:domain",
                content: "hypeempreendimentos.com.br"
            }, "twitterdomain"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: (ref22 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref22 !== void 0 ? ref22 : ""
            }, "twitterurl")
        ]
    });
}


/***/ }),

/***/ 8588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Formfale; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50121);
/* harmony import */ var _formfale_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53750);
/* harmony import */ var _formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function Formfale() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        hidden: true,
        className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bgfale),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            image: {
                src: "/img/fundocardvalores.webp"
            },
            width: "100%",
            height: "fit-content",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().titulofale),
                            children: [
                                "Fale com a gente, estamos",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                "aqui para te",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().textdec),
                                    children: "ajudar!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().padding), " mt-5"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inputform),
                                placeholder: "Nome completo",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inputform),
                                placeholder: "Endere\xe7o de e-mail",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inputform),
                                placeholder: "Telefone",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inputform),
                                placeholder: "Mensagem",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_formfale_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonenviar),
                                children: "Enviar mensagem!"
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 48704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NossosLancamentos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Buttons/ButtonDefault/index.tsx
var ButtonDefault = __webpack_require__(59000);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./utils/customLoaderImage.ts
var customLoaderImage = __webpack_require__(37265);
// EXTERNAL MODULE: ./components/Cards/CardCarouselLancamento/cardLancamento.module.scss
var cardLancamento_module = __webpack_require__(61628);
var cardLancamento_module_default = /*#__PURE__*/__webpack_require__.n(cardLancamento_module);
;// CONCATENATED MODULE: ./components/Cards/CardCarouselLancamento/index.tsx






function Lancamentos(param) {
    var lancamento = param.lancamento;
    var ref;
    if (!lancamento) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/apartamentos-a-venda/".concat(lancamento.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cardLancamento_module_default()).item,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: lancamento.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (lancamento === null || lancamento === void 0 ? void 0 : (ref = lancamento.image) === null || ref === void 0 ? void 0 : ref.url) || "",
                            loader: customLoaderImage/* customLoader */.l,
                            width: lancamento === null || lancamento === void 0 ? void 0 : lancamento.image.width,
                            height: lancamento === null || lancamento === void 0 ? void 0 : lancamento.image.height,
                            alt: lancamento.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                            children: [
                                "Imagem:",
                                lancamento.title
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    role: "button",
                    onKeyDown: function(event) {
                        return event.key === "Enter" && event.currentTarget.click();
                    },
                    tabIndex: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Ver mais"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowDropright */.kWz, {})
                    ]
                })
            ]
        }, lancamento.slug)
    });
}

// EXTERNAL MODULE: ./components/Carousel/CarouselCardsDefault/index.tsx + 2 modules
var CarouselCardsDefault = __webpack_require__(26476);
// EXTERNAL MODULE: ./pages/home/lancamentos.module.scss
var lancamentos_module = __webpack_require__(35860);
var lancamentos_module_default = /*#__PURE__*/__webpack_require__.n(lancamentos_module);
;// CONCATENATED MODULE: ./pages/home/lancamentos.tsx





function NossosLancamentos(param) {
    var lancamentos = param.lancamentos, texto = param.texto;
    if (!lancamentos || !texto) return null;
    var arrayCards = [
        lancamentos === null || lancamentos === void 0 ? void 0 : lancamentos.map(function(lancamento) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Lancamentos, {
                lancamento: lancamento
            }, lancamento === null || lancamento === void 0 ? void 0 : lancamento.id);
        }), 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (lancamentos_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (lancamentos_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: texto.texto.titulo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: texto.texto.conteudo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDefault/* default */.Z, {
                        url: "/apartamentos-a-venda",
                        text: "Ver mais",
                        aria: "Ver mais"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCardsDefault/* default */.Z, {
                seeMore: "/apartamentos-a-venda",
                children: arrayCards
            })
        ]
    });
}


/***/ }),

/***/ 43824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Noticias; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/BannerDefault/index.tsx
var BannerDefault = __webpack_require__(50121);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./utils/customLoaderImage.ts
var customLoaderImage = __webpack_require__(37265);
// EXTERNAL MODULE: ./components/Cards/CardCarouselBlog/cardCarouselBlog.module.scss
var cardCarouselBlog_module = __webpack_require__(52858);
var cardCarouselBlog_module_default = /*#__PURE__*/__webpack_require__.n(cardCarouselBlog_module);
;// CONCATENATED MODULE: ./components/Cards/CardCarouselBlog/index.tsx






function CardCarouselBlog(param) {
    var artigo = param.artigo;
    var ref, ref1, ref2, ref3;
    if (!artigo) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cardCarouselBlog_module_default()).item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: artigo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (artigo === null || artigo === void 0 ? void 0 : (ref = artigo.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url) || (artigo === null || artigo === void 0 ? void 0 : (ref3 = artigo.imagem) === null || ref3 === void 0 ? void 0 : ref3.url),
                        loader: customLoaderImage/* customLoader */.l,
                        alt: artigo.imagem.alt || "Imagem ilustrativa",
                        layout: "responsive",
                        objectFit: "cover",
                        quality: 100,
                        width: artigo.imagem.width,
                        height: artigo.imagem.height,
                        priority: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                        children: [
                            "Imagem:",
                            artigo.imagem.alt || "Imagem ilustrativa"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: artigo.text.toString().replace(/(<([^>]+)>)/gi, "").substring(0, 100).concat("...")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/blog/".concat(artigo.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Ver mais"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowDropright */.kWz, {})
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Carousel/CarouselCardsDefault/index.tsx + 2 modules
var CarouselCardsDefault = __webpack_require__(26476);
// EXTERNAL MODULE: ./pages/home/noticias.module.scss
var noticias_module = __webpack_require__(47240);
var noticias_module_default = /*#__PURE__*/__webpack_require__.n(noticias_module);
;// CONCATENATED MODULE: ./pages/home/noticias.tsx





function Noticias(param) {
    var artigos = param.artigos, background = param.background;
    if (!artigos) return null;
    var arrayCards = [
        artigos.map(function(art) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCarouselBlog, {
                artigo: art
            }, art.id);
        }), 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerDefault/* default */.Z, {
        image: {
            src: background === null || background === void 0 ? void 0 : background.imagem.url
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (noticias_module_default()).section,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "Confira nossas",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " ",
                        "\xfaltimas",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "not\xedcias!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCardsDefault/* default */.Z, {
                    seeMore: "/blog",
                    children: arrayCards
                })
            ]
        })
    });
}


/***/ }),

/***/ 67419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Politica; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59000);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _politica_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25029);
/* harmony import */ var _politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_politica_module_scss__WEBPACK_IMPORTED_MODULE_4__);






function Politica(param) {
    var dados = param.dados;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    if (!dados) return null;
    var banner = dados.banner, icones = dados.icones, textos = dados.textos;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: "/img/backgroundpolitica.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().lineDecorCenter)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                    className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: (banner === null || banner === void 0 ? void 0 : (ref = banner.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.medium) === null || ref2 === void 0 ? void 0 : ref2.url) || "/img/image_icon.png",
                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                            alt: (banner === null || banner === void 0 ? void 0 : banner.alt) || "",
                            width: banner === null || banner === void 0 ? void 0 : (ref3 = banner.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.medium) === null || ref5 === void 0 ? void 0 : ref5.width,
                            height: banner === null || banner === void 0 ? void 0 : (ref6 = banner.imagem) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sizes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.medium) === null || ref8 === void 0 ? void 0 : ref8.height,
                            objectFit: "cover",
                            layout: "responsive",
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                            children: banner === null || banner === void 0 ? void 0 : banner.alt
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: (ref9 = textos.find(function(txt) {
                                return txt.referencia === "home-qualidade";
                            })) === null || ref9 === void 0 ? void 0 : ref9.texto.titulo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: (ref10 = textos.find(function(txt) {
                                return txt.referencia === "home-qualidade";
                            })) === null || ref10 === void 0 ? void 0 : ref10.texto.conteudo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            url: "/qualidade-hype",
                            text: "Saiba mais!",
                            aria: "Saiba mais sobre a Hype!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().destaque),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().columnDecor)
                        }),
                        icones && icones.map(function(icone) {
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().lineDecor)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        src: icone.imagem.url,
                                                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                                                        alt: icone.imagem.alt,
                                                        width: 46,
                                                        height: 46
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: (ref = textos.find(function(txt) {
                                                        return txt.referencia === icone.referencia;
                                                    })) === null || ref === void 0 ? void 0 : ref.texto.conteudo
                                                })
                                            ]
                                        })
                                    }, icone.referencia)
                                ]
                            });
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 73652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sobrehype; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59000);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99814);
/* harmony import */ var _sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4__);






function Sobrehype(param) {
    var dados = param.dados;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    if (!dados) return null;
    var banner = dados.banner, texto1 = dados.texto1, texto2 = dados.texto2, texto3 = dados.texto3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "quemsomos",
        className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: texto1.texto.titulo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: texto1.texto.conteudo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemInfo),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: texto2.texto.titulo
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: texto2.texto.conteudo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemInfo),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: texto3.texto.titulo
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: texto3.texto.conteudo
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        url: "/sobre-nos",
                        text: "Saiba mais sobre a Hype!",
                        aria: "Saiba mais sobre a Hype!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: (_sobreHype_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: (banner === null || banner === void 0 ? void 0 : (ref = banner.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.medium) === null || ref2 === void 0 ? void 0 : ref2.url) || "/img/image_icon.png",
                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                        alt: banner === null || banner === void 0 ? void 0 : banner.alt,
                        width: banner === null || banner === void 0 ? void 0 : (ref3 = banner.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.medium) === null || ref5 === void 0 ? void 0 : ref5.width,
                        height: banner === null || banner === void 0 ? void 0 : (ref6 = banner.imagem) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sizes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.medium) === null || ref8 === void 0 ? void 0 : ref8.height,
                        objectFit: "cover",
                        layout: "responsive",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        children: "Imagem do predio da sede da Hype"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 49130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ValoresHype; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37265);
/* harmony import */ var _valores_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4757);
/* harmony import */ var _valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_valores_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function ValoresHype(param) {
    var dados = param.dados;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    if (!dados) return null;
    var banner = dados.banner, texto = dados.texto, icones = dados.icones, textoIcones = dados.textoIcones, background = dados.background;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: (_valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default().imageBackground),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        alt: background === null || background === void 0 ? void 0 : background.imagem.alt,
                        src: background === null || background === void 0 ? void 0 : background.imagem.url,
                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__/* .customLoader */ .l,
                        objectFit: "cover",
                        layout: "fill"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        children: background === null || background === void 0 ? void 0 : background.imagem.alt
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: (_valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default().image),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: (banner === null || banner === void 0 ? void 0 : (ref = banner.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.medium) === null || ref2 === void 0 ? void 0 : ref2.url) || "/img/image_icon.png",
                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__/* .customLoader */ .l,
                        alt: banner === null || banner === void 0 ? void 0 : banner.alt,
                        width: banner === null || banner === void 0 ? void 0 : (ref3 = banner.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.medium) === null || ref5 === void 0 ? void 0 : ref5.width,
                        height: banner === null || banner === void 0 ? void 0 : (ref6 = banner.imagem) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sizes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.medium) === null || ref8 === void 0 ? void 0 : ref8.height,
                        objectFit: "cover",
                        layout: "responsive",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        children: banner === null || banner === void 0 ? void 0 : banner.alt
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: texto.texto.titulo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: texto.texto.conteudo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_valores_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icons),
                        children: icones.map(function(icone, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: icone.imagem.url,
                                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__/* .customLoader */ .l,
                                        alt: icone.imagem.alt,
                                        width: 45,
                                        height: 45
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: textoIcones[index].texto.conteudo
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                        children: icone.imagem.alt
                                    })
                                ]
                            }, icone.referencia);
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_BannerDefault_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50121);
/* harmony import */ var _components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59000);
/* harmony import */ var _components_Carousel_CarouselDepoimentos__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25768);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38280);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55255);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37265);
/* harmony import */ var _utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34873);
/* harmony import */ var _home_formfale__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8588);
/* harmony import */ var _home_lancamentos__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48704);
/* harmony import */ var _home_noticias__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43824);
/* harmony import */ var _home_politica__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67419);
/* harmony import */ var _home_sobreHype__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73652);
/* harmony import */ var _home_valores__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49130);



















var __N_SSG = true;
function Home(param) {
    var homePage = param.homePage, lancamentos = param.lancamentos, artigos = param.artigos, depoimentos = param.depoimentos;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var rota = "https://hypeempreendimentos.com.br".concat(router.asPath);
    var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("(max-width: 768px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    data: {
                        titulo: homePage === null || homePage === void 0 ? void 0 : (ref = homePage.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.seo) === null || ref1 === void 0 ? void 0 : ref1.metaTitle,
                        descricao: homePage === null || homePage === void 0 ? void 0 : (ref2 = homePage.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.seo) === null || ref3 === void 0 ? void 0 : ref3.metaDescription,
                        imagem: homePage === null || homePage === void 0 ? void 0 : (ref4 = homePage.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.seo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ogImage) === null || ref6 === void 0 ? void 0 : ref6.url,
                        rota: rota
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_BannerDefault_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                image: {
                    src: (ref7 = (0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_17__/* .findImage */ .jw)(homePage === null || homePage === void 0 ? void 0 : homePage.imagens, "banner-principal")) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.imagem) === null || ref8 === void 0 ? void 0 : ref8.url
                },
                width: "100%",
                height: isMobile ? "30vh" : "70vh",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: homePage.textos.find(function(txt) {
                            return txt.referencia === "home-titulo-banner-principal";
                        }).texto.conteudo.length > 3 ? homePage.textos.find(function(txt) {
                            return txt.referencia === "home-titulo-banner-principal";
                        }).texto.conteudo : ""
                    }),
                    ((ref10 = homePage === null || homePage === void 0 ? void 0 : (ref9 = homePage.textos) === null || ref9 === void 0 ? void 0 : ref9.find(function(txt) {
                        return txt.referencia === "home-button-banner-principal";
                    })) === null || ref10 === void 0 ? void 0 : ref10.texto.conteudo.length) > 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        aria: (ref12 = homePage === null || homePage === void 0 ? void 0 : (ref11 = homePage.textos) === null || ref11 === void 0 ? void 0 : ref11.find(function(txt) {
                            return txt.referencia === "home-button-banner-principal";
                        })) === null || ref12 === void 0 ? void 0 : ref12.texto.titulo,
                        url: (ref14 = homePage === null || homePage === void 0 ? void 0 : (ref13 = homePage.textos) === null || ref13 === void 0 ? void 0 : ref13.find(function(txt) {
                            return txt.referencia === "home-button-banner-principal";
                        })) === null || ref14 === void 0 ? void 0 : ref14.texto.conteudo,
                        text: (ref16 = homePage === null || homePage === void 0 ? void 0 : (ref15 = homePage.textos) === null || ref15 === void 0 ? void 0 : ref15.find(function(txt) {
                            return txt.referencia === "home-button-banner-principal";
                        })) === null || ref16 === void 0 ? void 0 : ref16.texto.titulo,
                        target: "_blank"
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "#quemsomos",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            width: "30px",
                            height: "30px",
                            src: "/img/arrowdown.svg",
                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_18__/* .customLoader */ .l,
                            alt: "Ir para o texto quem somos",
                            priority: true,
                            style: {
                                cursor: "pointer"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_sobreHype__WEBPACK_IMPORTED_MODULE_15__["default"], {
                dados: {
                    banner: homePage === null || homePage === void 0 ? void 0 : homePage.imagens.find(function(img) {
                        return img.referencia === "home-quem-somos-imagem";
                    }),
                    texto1: homePage === null || homePage === void 0 ? void 0 : homePage.textos.find(function(txt) {
                        return txt.referencia === "home-quem-somos-1";
                    }),
                    texto2: homePage === null || homePage === void 0 ? void 0 : homePage.textos.find(function(txt) {
                        return txt.referencia === "home-quem-somos-2";
                    }),
                    texto3: homePage === null || homePage === void 0 ? void 0 : homePage.textos.find(function(txt) {
                        return txt.referencia === "home-quem-somos-3";
                    })
                }
            }),
            depoimentos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Carousel_CarouselDepoimentos__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                depoimentos: depoimentos
            }),
            lancamentos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_lancamentos__WEBPACK_IMPORTED_MODULE_12__["default"], {
                texto: homePage === null || homePage === void 0 ? void 0 : homePage.textos.find(function(txt) {
                    return txt.referencia === "home-lancamentos";
                }),
                lancamentos: lancamentos
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_politica__WEBPACK_IMPORTED_MODULE_14__["default"], {
                dados: {
                    banner: homePage === null || homePage === void 0 ? void 0 : homePage.imagens.find(function(img) {
                        return img.referencia === "home-qualidade-imagem";
                    }),
                    icones: homePage === null || homePage === void 0 ? void 0 : (ref17 = homePage.imagens) === null || ref17 === void 0 ? void 0 : ref17.filter(function(img) {
                        return img.referencia.includes("home-qualidade-politica");
                    }),
                    textos: homePage === null || homePage === void 0 ? void 0 : (ref18 = homePage.textos) === null || ref18 === void 0 ? void 0 : ref18.filter(function(txt) {
                        return txt.referencia.includes("home-qualidade");
                    })
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_valores__WEBPACK_IMPORTED_MODULE_16__["default"], {
                dados: {
                    banner: homePage === null || homePage === void 0 ? void 0 : homePage.imagens.find(function(img) {
                        return img.referencia === "home-valores-banner";
                    }),
                    texto: homePage === null || homePage === void 0 ? void 0 : (ref19 = homePage.textos) === null || ref19 === void 0 ? void 0 : ref19.find(function(txt) {
                        return txt.referencia === "home-valores-texto";
                    }),
                    icones: homePage === null || homePage === void 0 ? void 0 : (ref20 = homePage.imagens) === null || ref20 === void 0 ? void 0 : ref20.filter(function(img) {
                        return img.referencia.includes("home-valores-icone");
                    }),
                    textoIcones: homePage === null || homePage === void 0 ? void 0 : (ref21 = homePage.textos) === null || ref21 === void 0 ? void 0 : ref21.filter(function(txt) {
                        return txt.referencia.includes("home-valores-icone");
                    }),
                    background: homePage === null || homePage === void 0 ? void 0 : (ref22 = homePage.imagens) === null || ref22 === void 0 ? void 0 : ref22.find(function(img) {
                        return img.referencia === "home-valores-background";
                    })
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_noticias__WEBPACK_IMPORTED_MODULE_13__["default"], {
                artigos: artigos,
                background: homePage === null || homePage === void 0 ? void 0 : homePage.imagens.find(function(img) {
                    return img.referencia === "home-noticias-background";
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_formfale__WEBPACK_IMPORTED_MODULE_11__["default"], {})
        ]
    });
}


/***/ }),

/***/ 34873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jw": function() { return /* binding */ findImage; },
/* harmony export */   "xQ": function() { return /* binding */ imagemSizes; }
/* harmony export */ });
/* unused harmony export imagemSizeDestructure */
// eslint-disable-next-line import/prefer-default-export
var imagemSizeDestructure = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data;
    }
    return "";
};
var imagemSizes = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data.url;
    }
    return "";
};
var findImage = function(imagens, referencia) {
    return imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
        return img.referencia === referencia;
    });
};


/***/ }),

/***/ 67202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"bannerDefault_bannerContainer___FPrj","childrenContainer":"bannerDefault_childrenContainer__kGyT8"};

/***/ }),

/***/ 90050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"buttonDefault_buttonContainer__0nGtF"};

/***/ }),

/***/ 52858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"cardCarouselBlog_item__bfMej"};

/***/ }),

/***/ 61628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"cardLancamento_item__BQm4H"};

/***/ }),

/***/ 84746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"carouselDepoimentos_section__ygJ__","slider":"carouselDepoimentos_slider__60Kit","slide":"carouselDepoimentos_slide__KbjvB","cliente":"carouselDepoimentos_cliente__kq_hw","image":"carouselDepoimentos_image__Mi1bh","infoClient":"carouselDepoimentos_infoClient__iuaz4"};

/***/ }),

/***/ 53750:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgfale":"formfale_bgfale__x5q4a","textdec":"formfale_textdec__S6KjF","inputform":"formfale_inputform__Gt82H","buttonenviar":"formfale_buttonenviar__Dkcx_","padding":"formfale_padding___B92f","section":"formfale_section__fZet9","titulofale":"formfale_titulofale__ezP1I"};

/***/ }),

/***/ 35860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"lancamentos_section__Nkmye","text":"lancamentos_text__az3_c"};

/***/ }),

/***/ 47240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"noticias_section__gnzsB"};

/***/ }),

/***/ 25029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"politica_section__JPTpd","lineDecorCenter":"politica_lineDecorCenter__08zH7","image":"politica_image__dQY02","text":"politica_text__hKdUs","destaque":"politica_destaque__dgkni","icon":"politica_icon__VYWQ6","lineDecor":"politica_lineDecor__p7jFN","columnDecor":"politica_columnDecor__DwX85"};

/***/ }),

/***/ 99814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"sobreHype_section__Xjema","text":"sobreHype_text__QHody","info":"sobreHype_info__HbEYB","itemInfo":"sobreHype_itemInfo__nWm0m","image":"sobreHype_image__l6smm"};

/***/ }),

/***/ 4757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"valores_section__YJBE_","imageBackground":"valores_imageBackground__0e79_","card":"valores_card__V_1Fl","icons":"valores_icons__bblKl","image":"valores_image__VeRoo"};

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,4615,9520,3829,1072,9565,6476,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);